import { useEffect, useMemo, useRef, useState } from "react";
import { Card } from "../ui/card.jsx";
import { Button } from "../ui/button.jsx";
import { Input } from "../ui/input.jsx";
import { connectSocket, releaseSocket } from "../../lib/socket-client.js";

export default function PollsPanel({ roomId, socket: providedSocket }){
  const [poll, setPoll] = useState(null);
  const [results, setResults] = useState({});
  const [question, setQuestion] = useState("");
  const [options, setOptions] = useState("");
  const [selected, setSelected] = useState(null);
  const localSocketRef = useRef(null);

  useEffect(() => {
    if (providedSocket) {
      return () => {};
    }
    const sock = connectSocket();
    localSocketRef.current = sock;
    if (roomId) sock.emit("room:join", roomId);
    return () => {
      if (roomId) sock.emit("room:leave", roomId);
      localSocketRef.current = null;
      releaseSocket();
    };
  }, [providedSocket, roomId]);

  useEffect(() => {
    const sock = providedSocket || localSocketRef.current;
    if (!sock) return;
    const onNew = (data) => { setPoll({ question: data.question, options: data.options }); setSelected(null); setResults({}); };
    const onResults = (r) => setResults(r || {});
    sock.on("new-poll", onNew);
    sock.on("poll-results", onResults);
    return () => { sock.off("new-poll", onNew); sock.off("poll-results", onResults); };
  }, [providedSocket, roomId]);

  const create = () => {
    const q = (question || "").trim();
    const opts = (options || "").split(",").map((s)=>s.trim()).filter(Boolean);
    if (!roomId || !q || opts.length < 2) return;
    const sock = providedSocket || localSocketRef.current;
    sock?.emit("new-poll", { roomId, question: q, options: opts });
    setQuestion(""); setOptions("");
  };
  const vote = (opt) => {
    if (!roomId || !opt) return;
    const sock = providedSocket || localSocketRef.current;
    sock?.emit("vote", { roomId, option: opt });
    setSelected(opt);
  };

  return (
    <Card className="glass-card p-3">
      <div className="glass-header-blue flex items-center justify-between"><b>Polls & Quizzes</b></div>
      {!poll ? (
        <div className="mt-2 space-y-2">
          <Input placeholder="Question" value={question} onChange={(e)=>setQuestion(e.target.value)} />
          <Input placeholder="Options (comma-separated)" value={options} onChange={(e)=>setOptions(e.target.value)} onKeyDown={(e)=>{ if(e.key==="Enter") create(); }} />
          <div className="flex items-center justify-end"><Button size="sm" onClick={create}>Create</Button></div>
        </div>
      ) : (
        <div className="mt-2">
          <div className="font-medium mb-2">{poll.question}</div>
          <div className="grid gap-2">
            {poll.options.map((opt, i)=> (
              <Button key={i} variant={selected===opt?"default":"secondary"} className="justify-between" disabled={!!selected} onClick={()=>vote(opt)}>
                <span>{opt}</span>
                <span className="text-xs opacity-80">{results[opt] ?? 0}</span>
              </Button>
            ))}
          </div>
        </div>
      )}
    </Card>
  );
}
